$(document).ready(function () {
 const circles = $('.video-circle');
  let currentIndex = 0;

function playVideo(index) {
  if (!circles.length) return; // no circles

  circles.removeClass('active');

  circles.find('video').each(function () {
    this.pause();
    this.currentTime = 0;
  });

  const circle = circles.eq(index);
  if (!circle.length) return; // invalid index

  const video = circle.find('video').get(0);
  if (!video) return; // no video found

  circle.addClass('active');

  video.play().catch(function(error){
    console.log("Autoplay prevented:", error);
  });
                      setTimeout(function() {
$(".video-circle.active video").trigger('play');
}, 2500);
  currentIndex = index;
}


  // autoplay first video
if (circles.length > 0) {
  playVideo(0);
}


  // play next when finished
  circles.find('video').on('ended', function () {
    let next = currentIndex + 1;
    if (next >= circles.length) next = 0;
    playVideo(next);
  });

  // click → open modal
  circles.on('click', function () {
    const index = $(this).data('index');
    const src = $(this).find('source').attr('src');

    const modalVideo = $('.pdp-video-modal video').get(0);
    modalVideo.src = src;
    modalVideo.play();
    $("body").addClass('model_open');
    $('.pdp-video-modal').fadeIn(200);
    playVideo(index);
  });

  // close modal
  $('.modal-close, .modal-overlay').on('click', function () {
    const modalVideo = $('.pdp-video-modal video').get(0);
    modalVideo.pause();
    modalVideo.currentTime = 0;
    $('.pdp-video-modal').fadeOut(200);
        $("body").removeClass('model_open');

  });
 $(document).on('click', '.read-more-toggle', function () {
    var $wrapper = $(this).closest('.read-more-wrapper');
    var $short = $wrapper.find('.read-more-short');
    var $full = $wrapper.find('.read-more-full');
    var check_button_more = $(".read-more-toggle").attr('data-more');
    var check_button_less = $(".read-more-toggle").attr('data-less');
    if ($full.is(':visible')) {
      $full.hide();
      $short.show();
      $(this).text(check_button_more);
    } else {
      $short.hide();
      $full.show();
      $(this).text(check_button_less);
    }
  });



  var $button = $("#atc-test-id");

  $button.on("click", function () {

    var $before = $(this).find(".before_clicked_text");
    var $after  = $(this).find(".clicked_text");

    // Switch text
    $before.hide();
    $after.show();

    // Switch back after 1 second
    setTimeout(function () {
      $after.hide();
      $before.show();
    }, 1000);

  });

});